module.exports = __webpack_public_path__ + "img/minus.e1183942.svg";